import {debounce, el, on, template} from "../adapters/backbone-decorators";
import GenericView from 'js/views/generic.view';
import CreditsEmailReservedCollection from 'js/models/credits.email.reserved.paginated.collection';
import PaginatedView from 'js/views/pagination.view';
import Template from 'js/templates/credits.email.reserved.hbs';

require('backboneAdapter');
require('jqueryUI');
require('metroHelpers');

@el('#credits-email-reserved-container')
@template(Template)
class CreditsEmailReservedView extends GenericView {

    constructor() {
        super();
        this.textFilter = "";
        this.collection = new CreditsEmailReservedCollection();
        this.collection.on('sync', this.renderCollection, this);
        this.collection.getFirstPage();
    }

    render() {
        super.render();
    }

    renderCollection() {
        if (this.collection.models[0].get("data")[0]) {
            this.trial = this.collection.models[0].get("data")[0].trial;
        }
        const tempTemplate = this.template({
            collection: this.collection.data,
            trial: this.trial
        });
        this.$el.html(tempTemplate);
        const $searchbox = this.$el.find('.searchbox');
        $searchbox.val(this.textFilter);
        $searchbox.focus();
        this.$('[data-i18n]').i18n();
        if (this.pagination) {
            this.pagination.remove();
        }
        this.pagination = new PaginatedView({collection: this.collection});
        this.pagination.render();
        this.$('#pagination').html(this.pagination.$el);
    }

    @on('keyup .searchbox')
    @debounce(800)
    searchByFilter(event) {
        const value = event.currentTarget.value;
        this.textFilter = value;
        const baseUrl = `/CampaignCloud/CreditsController/Reservations`;
        this.collection.url = value ? `${baseUrl}?filter=${this.textFilter}` : baseUrl;
        this.collection.getFirstPage();
    }
}

export default CreditsEmailReservedView;
